<template>
  <section class="container edit-topic">
    <nav>
      <ul class="nav-list">
        <li v-for="item of nav" :key="item.url" class="nav-list-item">
          <router-link :to="item.url">{{ item.title }} </router-link>
        </li>
        <li class="nav-list-item back">
          <yn-button color="primary" variant="text" @click="$router.push(`/topics`)">Back to list</yn-button>
        </li>
      </ul>
    </nav>
    <section v-if="!!item">
      <router-view></router-view>
    </section>
    <section v-else></section>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './../common/Button';

export default {
  components: {
    'yn-button': Button
  },
  meta: {
    title: 'Manage Topic'
  },
  data() {
    return {
      nav: [
        {
          title: 'General',
          url: `/topics/${this.$route.params.id}/edit/`
        },
        {
          title: 'Members',
          url: `/topics/${this.$route.params.id}/edit/members`
        },
        {
          title: 'Data',
          url: `/topics/${this.$route.params.id}/edit/data`
        },
        {
          title: 'Integrations',
          url: `/topics/${this.$route.params.id}/edit/integrations`
        }
      ]
    };
  },
  computed: {
    ...mapState({
      item: s => s.topics.item,
      isGetRequestPending: s => s.topics.isGetRequestPending,
      isUpdateRequestPending: s => s.topics.isUpdateRequestPending,
      isUpdateRequestFailed: s => s.topics.isUpdateRequestFailed
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('topics/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('topics/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Topic was updated.`
        });
        this.$router.push({ path: `/` });
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-topic {
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: 200px minmax(0, 1fr);

  nav {
    padding: 2rem 0;
    .nav-list {
      list-style: none;
    }

    .nav-list-item {
      // border: 1px solid #e1e1e1;
      a {
        width: 100%;
        display: flex;
        align-items: center;
        color: #2d313d;
        padding: 1rem 2rem;
        font-size: 0.85rem;
        font-weight: 700;
        border-radius: 28px;
        text-transform: uppercase;
      }
      a.router-link-exact-active {
        background-color: #2d313d;
        color: #fff;
      }

      &.back {
        padding: 2rem;

        display: flex;
        button {
          padding-left: 0;
        }
      }
    }
  }
}
</style>
